export const ROOT_LHR_SUMMARY = '/lhr_summary';
export const CREATE_LHR_SUMMARY = `${ROOT_LHR_SUMMARY}/create`;
export const UPDATE_LHR_SUMMARY = `${ROOT_LHR_SUMMARY}`;
export const FETCH_LOTS = `document_revisions/lots_of_part${ROOT_LHR_SUMMARY}`;
